import React, { useState, useEffect } from 'react'
import { MonetizationOn, } from '@material-ui/icons'
import { Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'
import formatCurrency from 'utils/formatCurrency'
import ActionChip from 'components/JarCard/ActionChip'
import ConfirmDialog from 'components/JarCard/PayoutChip/ConfirmDialog'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import useEntity from 'hooks/useEntity'

const minPayoutDollarAmount = 20

const PayoutChip = ({ jarId }) => {
  const { transferableDonationsSum } = useEntity('campaigns', jarId)
  const { search, pathname } = useLocation()
  const { payoutJar } = queryString.parse(search)
  const { replace } = useHistory()
  const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    // NOTE: This is to handle re-opening the dialog upon completing stripe connect which requires
    // a redirect. There might be a cleaner way of doing this e.g. associating dialogs with dynamic
    // routes using jar ids but this will do for now
    if(payoutJar === jarId) {
      replace(pathname)
      setDialogOpen(true)
    }
  }, [payoutJar, jarId, pathname, replace])

  function Chip(additionalProps) {
    return (
      <ActionChip
        labelText={`Payout Balance: ${formatCurrency(transferableDonationsSum)}`}
        handleClick={() => setDialogOpen(true)}
        Icon={MonetizationOn}
        {...additionalProps}
      />
    )
  }

  if (transferableDonationsSum > minPayoutDollarAmount) {
    return (
      <React.Fragment>
        <Chip />
        <ConfirmDialog
          open={dialogOpen}
          jarId={jarId}
          handleClose={() => setDialogOpen(false)}
          amount={transferableDonationsSum}
        />
      </React.Fragment>
    )
  }

  return <Disabled ChipComponent={Chip} />
}

function Disabled({ ChipComponent }) {
  return (
    <Tooltip
      enterTouchDelay={0}
      disableFocusListener title={`Balance must exceed ${formatCurrency(minPayoutDollarAmount)} to payout`}
    >
      <div>
        <ChipComponent disabled />
      </div>
    </Tooltip>
  )
}

PayoutChip.propTypes = {
  jarId: PropTypes.string.isRequired
}

export default PayoutChip
